import axios from 'axios'

import storage from '@/utils/storage'
import website from '@/config/website'
import { Message } from 'element-ui'


//新的axios实例
let instance = axios.create({
  baseURL:process.env.VUE_APP_BASE_API,
  timeout:5000
});

//请求拦截器
instance.interceptors.request.use( config => {
  //让每个请求携带token
  const meta = (config.meta || {});
  const isToken = meta.isToken === false;
  if (storage.getStore({ name: 'token' }) && !isToken) {
    config.headers['Authorization'] = 'bearer ' + storage.getStore({name:'token'});
  }
  return config
}, error => {
    return Promise.reject(error)
})

//http response 拦截
instance.interceptors.response.use(res => {
    //获取状态码
    const status = res.data.code || res.status;
    const statusWhiteList = website.statusWhiteList || [];
    let errMessage = res.data.msg || res.data.error_description || res.message || '未知错误';
    //如果在白名单里则自行catch逻辑处理
    if (statusWhiteList.includes(status)) return Promise.reject(res);
    //如果是401则跳转到登录页面
    if (status === 401) Message.error('操作失败，无权限');
    if (status === 403) { 
      window.location.href="/login"
      Message.error('登录失效，请重新登录');
    }
    // 如果请求为非200否者默认统一处理
  if (status !== 200) {
      return Promise.reject({code:status,msg:errMessage})
    }
    return res;
}, error => {
  return Promise.reject({msg:error.message});
  });

export default instance;